// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"MediaGridImages_testimonial__d_8pM","isSmallTestimonial":"MediaGridImages_isSmallTestimonial__KrCmk"};